export enum UserType {
  ADMIN = 1,
  TEACHER = 2,
  REGULAR_USER = 3,
  SCHOOL_USER = 4
}